import { Suspense, useEffect, lazy } from 'react';
import { ThemeProvider } from '@mui/styles';
import { createTheme, responsiveFontSizes } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LoadingScreen from './components/loading/LoadingScreen';
const Home = lazy(() => import('./pages/Home'));

let theme = createTheme();
theme = responsiveFontSizes(theme);

const App = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      delay: 50,
      duration: 500,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <Suspense
      fallback={
        <div style={{ position: 'absolute', top: `${30}%`, left: `${40}%` }}>
          <LoadingScreen text="Loading..." type="Watch" color="#F64D28" />
        </div>
      }
    >
      <ThemeProvider theme={theme}>
        <Home />
      </ThemeProvider>
    </Suspense>
  );
};

export default App;
